import { RouterProvider } from 'react-aria-components';
import { Outlet, useHref, useNavigate } from 'react-router';

// Without this, react-aria links (every @tgtg/kit NavigationBar item) keep
// their default isNative router and do a full page load instead of a
// client-side navigation.
const AriaRouterProvider = () => {
  const navigate = useNavigate();

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <Outlet />
    </RouterProvider>
  );
};

export default AriaRouterProvider;
